export default __webpack_public_path__ + "static/media/previewPlaceholder.0d5bd1c8.svg";